import React, { useState, useEffect } from 'react';
import { fetchStudents, exportStudentsExcel } from '../services/academicFinanceApi';
import { FinanceTable } from './FinanceTable';
import Notifier from '../../../Utils/notify';
import exporticon from '../../../assets/icons/export-data.svg';

export const StudentsList = ({ leastAcademicGroupId, onUpdateGrandTotals }) => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [exporting, setExporting] = useState(false);
  const pageSize = 10;

  useEffect(() => {
    loadStudents(currentPage);
  }, [currentPage, leastAcademicGroupId]);

  const loadStudents = async (page) => {
    try {
      setLoading(true);
      const data = await fetchStudents(leastAcademicGroupId, page, pageSize);
      setStudents(data.results || []);
      
      if (data.grand_totals) {
        onUpdateGrandTotals(data.grand_totals);
      }
      
      if (data.count) {
        setTotalPages(Math.ceil(data.count / pageSize));
      }
    } catch (error) {
      console.error('Error loading students:', error);
      Notifier.error('Failed to load students');
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      setExporting(true);
      await exportStudentsExcel(leastAcademicGroupId);
      Notifier.success('Students data exported successfully');
    } catch (error) {
      console.error('Error exporting students:', error);
      Notifier.error('Failed to export students data');
    } finally {
      setExporting(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    { header: 'ID', accessor: 'id', width: '80px' },
    { header: 'Name', accessor: 'name', width: '200px' },
    { header: 'Mobile', accessor: 'mobile', width: '130px' },
    { header: 'Registration Number', accessor: 'registration_number', width: '180px' },
    { header: 'Course', accessor: 'course_name', width: '180px' },
    { 
      header: 'Imposed Fees', 
      accessor: 'total_imposed_fees', 
      width: '140px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Scheduled Fees', 
      accessor: 'total_scheduled_fee', 
      width: '140px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Paid Fees', 
      accessor: 'total_paid_fees', 
      width: '140px',
      align: 'right',
      format: 'currency'
    },
  ];

  return (
    <div className="students-list">
      <div className="list-header">
        <h2>Students</h2>
        <button 
          className="export-btn" 
          onClick={handleExport}
          disabled={exporting}
        >
          <img src={exporticon} alt="Export" />
          {exporting ? 'Exporting...' : 'Export'}
        </button>
      </div>

      <FinanceTable
        data={students}
        columns={columns}
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onRowClick={null} // Students don't drill down further
      />
    </div>
  );
};
